class ProductTemplate extends HTMLElement {
    constructor() {
        super();

        this._productCache = new Map();   // cache { handle -> product.json }
        this._progressCurrent = 0;
    }

    connectedCallback() {
        this.initSwiper();
        this.initVideoOptimization();
        this.calculateShipping();
        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });

        this.initQuantitySteps();
        this.updateButtonPrice();


        this.querySelectorAll('[data-open-modal]').forEach((button) => {
            button.addEventListener('click', (e) => {
                this.openModal(e.currentTarget.getAttribute('data-product-handle'));
            });
        });


        this.querySelectorAll('.product-form__submit[data-action="add-to-cart"]').forEach((button) => {
            button.addEventListener('click', async (e) => {
                e.preventDefault();
                const variantId = button.getAttribute('variant-id');
                const qty = button.getAttribute('data-quantity') || 1;
                const properties = button.getAttribute('data-properties') ? JSON.parse(button.getAttribute('data-properties')) : null;

                // Disable the button and change text to indicate loading
                const originalText = button.innerHTML;
                const originalText2 = this.querySelector('.product-form__sticky-submit-button button').innerHTML;
                button.disabled = true;
                button.setAttribute('aria-busy', 'true');
                button.innerHTML = '<span class=" fw-6">AJOUT... </span>';
                this.querySelector('.product-form__sticky-submit-button button').innerHTML = '<span class=" fw-6">AJOUT... </span>';
                try {
                    const randomId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                    const finalProperties = { ...(properties || {}), _random: randomId };

                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                        },
                        body: JSON.stringify({ id: variantId, quantity: qty, properties: finalProperties }),
                        credentials: 'same-origin',
                    });
                    button.innerHTML = '<span class=" fw-6">AJOUTÉ </span>';

                    this.querySelector('.product-form__sticky-submit-button button').innerHTML = '<span class=" fw-6">AJOUTÉ </span>';

                    // Dispatch product:added event for sidecart to handle
                    document.dispatchEvent(new CustomEvent('product:added'));

                    // Open the sidecart
                    const sideCart = document.querySelector('side-cart');
                    if (sideCart) {
                        sideCart.classList.add('open');
                    }

                    await this.refreshQuantitySteps();
                    await this.updateButtonPrice();

                } catch (error) {
                    console.error('Erreur lors de l’ajout au panier:', error);
                    button.innerHTML = originalText; // Restore original text on error
                } finally {
                    button.disabled = false;
                    button.removeAttribute('aria-busy');
                    button.innerHTML = originalText; // Restore original text on error
                    this.querySelector('.product-form__sticky-submit-button button').innerHTML = originalText2; // Restore original text on error
                }
            });
        });


        this.querySelector('.product-form__sticky-submit-button button').addEventListener('click', (e) => {
            this.querySelector('.product-form__submit[data-action="add-to-cart"]').click();
        })



        // when .product-form__content is out of view, add the class 'is-open' from .product-form__sticky
        const productFormContent = this.querySelector('.product-form');
        const productFormSticky = this.querySelector('.product-form__sticky');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    productFormSticky.classList.add('is-open');
                } else {
                    productFormSticky.classList.remove('is-open');
                }
            });
        }, {
            root: null,
            threshold: 0.1 // Trigger when 10% of the element is visible
        });

        observer.observe(productFormContent);
        // Set the initial state of the sticky element
        if (productFormContent.getBoundingClientRect().top < window.innerHeight) {
            productFormSticky.classList.remove('is-open');
        }
    }

    initSwiper() {
        const swiperContainer = this.querySelector('.product-media__slider');

        const swiper = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 6,
            pagination: {
                el: '.product-media__slider .swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.product-media__slider .swiper-next',
                prevEl: '.product-media__slider .swiper-prev',
            },
            breakpoints: {
                990: {
                    slidesPerView: 1,
                },
            },
            on: {
                slideChange: () => {
                    this.handleVideoSlideChange(swiper);
                }
            }
        });

        // Store swiper instance for video management
        this.swiperInstance = swiper;
    }

    initVideoOptimization() {
        const videos = this.querySelectorAll('.product-media__video, .product-media__bottom-video');

        // Intersection Observer pour détecter quand les vidéos entrent dans la vue
        const videoObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const video = entry.target;
                if (entry.isIntersecting) {
                    this.loadAndPlayVideo(video);
                } else {
                    this.pauseVideo(video);
                }
            });
        }, {
            root: null,
            threshold: 0.5 // Déclenche quand 50% de la vidéo est visible
        });

        videos.forEach(video => {
            videoObserver.observe(video);

            // Gestion des erreurs de chargement
            video.addEventListener('error', () => {
                console.warn('Erreur de chargement vidéo, fallback sur poster');
                video.style.backgroundImage = `url(${video.poster})`;
                video.style.backgroundSize = 'cover';
                video.style.backgroundPosition = 'center';
            });

            // Lazy loading optimisé
            video.addEventListener('loadstart', () => {
                video.style.opacity = '0';
                video.style.transition = 'opacity 0.3s ease';
            });

            video.addEventListener('loadeddata', () => {
                video.style.opacity = '1';
            });
        });
    }

    loadAndPlayVideo(video) {
        // Ne charge la vidéo que si elle n'est pas déjà chargée
        if (video.readyState === 0) {
            video.load();
        }

        // Play seulement si la vidéo est prête
        const playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.catch(error => {
                console.warn('Autoplay bloqué par le navigateur:', error);
            });
        }
    }

    pauseVideo(video) {
        if (!video.paused) {
            video.pause();
        }
    }

    handleVideoSlideChange(swiper) {
        // Pause toutes les vidéos sauf celle du slide actif
        const allVideos = this.querySelectorAll('.product-media__video');
        const activeSlide = swiper.slides[swiper.activeIndex];
        const activeVideo = activeSlide ? activeSlide.querySelector('.product-media__video') : null;

        allVideos.forEach(video => {
            if (video !== activeVideo) {
                this.pauseVideo(video);
            }
        });

        // Play la vidéo du slide actif si elle existe
        if (activeVideo) {
            this.loadAndPlayVideo(activeVideo);
        }
    }

    async getCart() {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Cart fetch failed');
        return res.json();
    }

    async getProductJSONByHandle(handle) {
        if (this._productCache.has(handle)) return this._productCache.get(handle);
        const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`Product fetch failed: ${handle}`);
        const data = await res.json();
        this._productCache.set(handle, data);

        return data;
    }

    async countBarzPacksInCart() {
        const cart = await this.getCart();
        let total = 0;
        // On limite les requêtes en parallèle et on cache par handle.
        const tasks = cart.items.map(async (item) => {
            try {
                // Exclude free items (final_price = 0) from count
                if (item.final_price === 0) {
                    console.log(`Excluding free item from count: ${item.title}`);
                    return;
                }

                const p = await this.getProductJSONByHandle(item.handle);
                // tags est un tableau de strings
                if (Array.isArray(p.tags) && p.tags.includes('tag_barz')) {
                    total += item.quantity;
                }
            } catch (e) {
                console.warn('Impossible de lire le produit du panier:', item.handle, e);
            }
        });
        await Promise.all(tasks);
        return total;
    }

    readStepsConfig() {
        const steps = this.querySelectorAll('.quantity_step__step.step');
        const barEl = this.querySelector('.quantity_step__progress-bar');

        let maxStep = 0;
        steps.forEach((el) => {
            const v = parseInt(el.getAttribute('data-quantity-step'), 10);
            if (!isNaN(v)) maxStep = Math.max(maxStep, v);
        });

        return { steps, barEl, maxStep };
    }

    /**
     * Met à jour l'état actif des steps en fonction de la quantité totale calculée.
     * Déclenche aussi tes animations CSS grâce à la classe .active.
     */
    updateStepsActive(totalQty) {
        const { steps } = this.readStepsConfig();
        steps.forEach((el) => {
            const threshold = parseInt(el.getAttribute('data-quantity-step'), 10) || 0;
            if (totalQty >= threshold && threshold > 0) {
                el.classList.add('active');
            } else {
                el.classList.remove('active');
            }
        });
    }

    /**
     * Met à jour la progress bar.
     * - Calcule le pourcentage = totalQty / maxStep (limité à 100%)
     * - Anime depuis this._progressCurrent vers la nouvelle largeur
     */
    updateProgressBar(totalQty, { animate = true } = {}) {
        const { barEl, maxStep } = this.readStepsConfig();
        if (!barEl || !maxStep) return;

        const target = Math.max(0, Math.min(100, (totalQty / maxStep) * 100));
        // Transition douce
        if (animate) {
            barEl.style.transition = 'width 300ms ease';
        } else {
            barEl.style.transition = 'none';
        }
        // Part d'où on est (au 1er init on essaie de lire le style inline)
        if (this._progressCurrent === 0) {
            const inline = parseFloat((barEl.style.width || '').replace('%', ''));
            if (!isNaN(inline)) this._progressCurrent = inline;
        }

        // Fixe la nouvelle largeur
        barEl.style.width = `${target}%`;
        this._progressCurrent = target;
    }

    /**
     * Init général: compte dans le panier, active les steps, puis règle la barre.
     */
    async initQuantitySteps() {
        // Si la section steps n’existe pas, on sort
        const stepsWrap = this.querySelector('.quantity_step--container');
        if (!stepsWrap) return;

        try {
            const totalBarz = await this.countBarzPacksInCart();
            // Steps actifs/inactifs
            this.updateStepsActive(totalBarz);
            // Progress bar (sans animation à l’init)
            this.updateProgressBar(totalBarz, { animate: false });
        } catch (e) {
            console.warn('Init steps/progress échouée:', e);
        }
    }

    /**
     * Recalcule après ajout au panier (avec animation cette fois).
     */
    async refreshQuantitySteps() {
        const stepsWrap = this.querySelector('.quantity_step--container');
        if (!stepsWrap) return;

        try {
            const totalBarz = await this.countBarzPacksInCart();
            this.updateStepsActive(totalBarz);
            this.updateProgressBar(totalBarz, { animate: true });
        } catch (e) {
            console.warn('Refresh steps/progress échouée:', e);
        }
    }

    getApplicableReduction(totalQty) {
        const steps = this.querySelectorAll('.quantity_step__step.step');
        let applicableReduction = 0;
        let highestThreshold = 0;

        steps.forEach((el) => {
            const threshold = parseInt(el.getAttribute('data-quantity-step'), 10) || 0;
            const reductionText = el.querySelector('.quantity_step__step-reduction')?.textContent || '';
            const reduction = parseInt(reductionText.replace('-', '').replace('%', ''), 10) || 0;

            if (totalQty >= threshold && threshold > highestThreshold) {
                highestThreshold = threshold;
                applicableReduction = reduction;
            }
        });

        return applicableReduction;
    }

    async updateButtonPrice() {
        const stepsWrap = this.querySelector('.quantity_step--container');
        if (!stepsWrap) return;

        const submitButton = this.querySelector('.product-form__submit[data-action="add-to-cart"]');
        const stickyButton = this.querySelector('.product-form__sticky-submit-button button');
        if (!submitButton) return;

        try {
            const totalBarz = await this.countBarzPacksInCart();
            // Calculate reduction for NEXT item (totalBarz + 1)
            const reduction = this.getApplicableReduction(totalBarz + 1);

            // Get original price from data attribute (in cents)
            const originalPriceInCents = parseFloat(submitButton.getAttribute('data-original-price'));
            const originalPrice = originalPriceInCents / 100; // Convert cents to euros

            // Calculate discounted price if reduction applies
            let discountedPrice = reduction > 0 ? originalPrice * (1 - reduction / 100) : originalPrice;

            // Round to 2 decimals first
            discountedPrice = Math.round(discountedPrice * 100) / 100;

            // Round .96 to .95
            const cents = Math.round((discountedPrice % 1) * 100);
            if (cents === 96) {
                discountedPrice = Math.floor(discountedPrice) + 0.95;
            }

            // Format prices
            const formattedDiscountedPrice = new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR'
            }).format(discountedPrice);

            const formattedOriginalPrice = new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR'
            }).format(originalPrice);

            // Helper function to update button prices
            const updateButton = (button) => {
                const priceContainer = button.querySelector('[variant-price-change]');
                if (!priceContainer) return;

                const priceElement = priceContainer.querySelector('.product-form__price');
                const comparePriceElement = priceContainer.querySelector('.product-form__compare-price');

                if (!priceElement) return;

                if (reduction > 0) {
                    // Show original price crossed out and discounted price
                    if (comparePriceElement) {
                        comparePriceElement.textContent = formattedOriginalPrice;
                        comparePriceElement.parentElement.style.display = '';
                    }
                    priceElement.textContent = formattedDiscountedPrice;
                } else {
                    // No reduction, show normal price
                    priceElement.textContent = formattedOriginalPrice;
                    if (comparePriceElement && comparePriceElement.parentElement) {
                        comparePriceElement.parentElement.style.display = 'none';
                    }
                }
            };

            // Update main submit button
            updateButton(submitButton);

            // Update sticky button
            if (stickyButton) {
                updateButton(stickyButton);
            }
        } catch (e) {
            console.warn('Update button price échouée:', e);
        }
    }

    openModal(productHandle) {
        const modal = document.querySelector('.modal-product__content');
        if (modal) {
            modal.classList.add('is-open');
            modal.innerHTML = ''; // Clear previous content
            fetch(`/products/${productHandle}?section_id=pop-up-product`)
                .then(response => response.text())
                .then(html => {
                    modal.innerHTML = html;
                    setTimeout(() => {
                        this.querySelector('.section-pop-up-product').classList.add('active');
                    }, 100);

                    this.querySelector('.section-pop-up-product .pop-up__header svg').addEventListener('click', () => {
                        this.querySelector('.section-pop-up-product').classList.remove('active');
                        setTimeout(() => {
                            modal.classList.remove('is-open');
                        }, 100);
                    });
                    this.querySelector('.pop-up__overlay').addEventListener('click', () => {
                        this.querySelector('.section-pop-up-product').classList.remove('active');
                        setTimeout(() => {
                            modal.classList.remove('is-open');
                        }, 100);
                    });
                })
                .catch(error => console.error('Error loading product modal:', error));
        }
    }


    toggleFaqItem(e) {
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        e.currentTarget.parentNode.classList.toggle("faq-item-active");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
        console.log(item);

        item.slideToggle("250");
    }

    calculateShipping() {
        if (this.querySelector(".sidecart-form__icon")) {
            // calculate shipping date from today + shipping delay exclude weekends
            let shipping_date = new Date(new Date().getTime());

            let shipping_delay = parseInt(
                this.querySelector(".sidecart-form__icon").getAttribute(
                    "data-shipping-delay"
                )
            );

            if (shipping_delay == null) {
                shipping_delay = parseInt(
                    this.querySelector(".cart-form__icon").getAttribute(
                        "data-shipping-delay"
                    )
                );
            }

            for (var i = 0; i < shipping_delay; i++) {
                shipping_date.setDate(shipping_date.getDate() + 1);
                if (shipping_date.getDay() == 6) {
                    shipping_date.setDate(shipping_date.getDate() + 2);
                }
                if (shipping_date.getDay() == 0) {
                    shipping_date.setDate(shipping_date.getDate() + 1);
                }
            }

            // get french date format day month year
            let shipping_date_format = shipping_date.toLocaleDateString("fr-FR", {
                weekday: "long",
                day: "numeric",
                month: "long",
            });

            for (
                let i = 0;
                i < document.querySelectorAll(".sidecart-form__icon").length;
                i++
            ) {
                let html = document.querySelectorAll(".sidecart-form__icon")[i]
                    .innerHTML;
                if (html.indexOf("[date]") > -1) {
                    document.querySelectorAll(".sidecart-form__icon")[i].innerHTML =
                        html.replace("[date]", shipping_date_format);
                }
            }

            for (
                let i = 0;
                i < document.querySelectorAll(".cart-form__icon").length;
                i++
            ) {
                let html = document.querySelectorAll(".cart-form__icon")[i].innerHTML;
                if (html.indexOf("[date]") > -1) {
                    if (document.querySelector(".cart-form__icon")) {
                        document.querySelectorAll(".cart-form__icon")[i].innerHTML =
                            html.replace("[date]", shipping_date_format);
                    }
                }
            }
        }
    }

}

customElements.define('product-form', ProductTemplate);